import { render, staticRenderFns } from "./PlayerRegistration.vue?vue&type=template&id=59cf4fd0&scoped=true&"
import script from "./PlayerRegistration.vue?vue&type=script&lang=ts&"
export * from "./PlayerRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf4fd0",
  null
  
)

export default component.exports